function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#FCF7CB",
  d: "M1.75 39.95v-.1c0-4.7 3.8-8.5 8.45-8.5l38-.05.05 17.05-38 .05c-4.65.05-8.45-3.75-8.5-8.45z"
}), React.createElement("path", {
  fill: "#E0F1C0",
  d: "M4.3 34L31.1 6.8l12 12L16.3 46z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M20.2 50.05c-.85 0-1.5-.65-1.5-1.5s.65-1.5 1.5-1.5L46.75 47V32.95l-14.7.05c-.85 0-1.5-.65-1.5-1.5s.65-1.5 1.5-1.5l16.15-.05c.4 0 .8.15 1.05.45.3.3.45.65.45 1.05l.05 17.05c0 .85-.65 1.5-1.5 1.5l-28.05.05z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M23.3 40.5c-.4 0-.75-.15-1.05-.45-.6-.6-.6-1.55 0-2.1L41 18.8l-9.9-9.9L5.35 35.05c-.6.6-1.55.6-2.1 0-.6-.6-.6-1.55 0-2.1l26.8-27.2c.3-.3.65-.45 1.05-.45s.8.15 1.05.45l12 12c.6.6.6 1.5 0 2.1l-19.8 20.2c-.3.3-.7.45-1.05.45z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M10.3 48.45c-4.65 0-8.45-3.8-8.45-8.45V1.55h16.9V40a8.44 8.44 0 0 1-8.45 8.45"
}), React.createElement("path", {
  fill: "#E4E9A8",
  d: "M18.75 21.6H1.85v9.8h16.9v-9.8"
}), React.createElement("path", {
  fill: "#BEE9A8",
  d: "M18.75 11.8H1.85v9.8h16.9v-9.8"
}), React.createElement("path", {
  fill: "#A8E9CE",
  d: "M1.85 1.55h16.9v9.8H1.85z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M18.75 32.9H1.85c-.85 0-1.5-.65-1.5-1.5s.65-1.5 1.5-1.5h16.9c.85 0 1.5.65 1.5 1.5s-.65 1.5-1.5 1.5zm-.6-9.8H2.1c-.85 0-1.5-.65-1.5-1.5s.65-1.5 1.5-1.5h16.05c.85 0 1.5.65 1.5 1.5s-.7 1.5-1.5 1.5zm.6-10.25H1.85c-.85 0-1.5-.65-1.5-1.5s.65-1.5 1.5-1.5h16.9c.85 0 1.5.65 1.5 1.5s-.65 1.5-1.5 1.5z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M10.3 49.95C4.8 49.95.35 45.5.35 40V1.55C.35.7 1 .05 1.85.05h16.9c.85 0 1.5.65 1.5 1.5V40c0 5.5-4.45 9.95-9.95 9.95zM3.35 3.05V40c0 3.85 3.1 6.95 6.95 6.95s6.95-3.1 6.95-6.95V3.05H3.35z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M10.3 43.65c-2 0-3.6-1.65-3.6-3.65s1.6-3.65 3.6-3.65S13.9 38 13.9 40s-1.6 3.65-3.6 3.65zm0-4.25c-.35 0-.6.3-.6.65 0 .35.25.65.6.65s.6-.3.6-.65c.05-.4-.25-.65-.6-.65z"
}));

var SvgPaletteExtra = function SvgPaletteExtra(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPaletteExtra, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/palette-extra.2f64abe1.svg";
export { ForwardRef as ReactComponent };